export const PAYMENT_URLS = {
  PLANS: 'subscriptions/plans',
  ADDONS: 'subscriptions/addons',
  CURRENT_SUBSCRIPTION_PLAN: 'clients/subscription',
  CHANGE_SUBSCRIPTION_PLAN: 'clients/subscription/change',
  CANCEL_SCHEDULED_SUBSCRIPTION_PLAN: 'clients/subscription/cancel-scheduled',
  GET_SUBSCRIPTION_SIGNATURES: 'clients/subscription/signatures',
  CANCEL_SUBSCRIPTION: 'clients/subscription/cancel',
  REMOVE_SCHEDULED_SUBSCRIPTION_CANCELLATION: 'clients/subscription/remove-scheduled-cancellation',
  GET_PAYMENT_HISTORY: 'payments/history',
  GET_PAYMENT_HISTORY_PDF: (id: string) => `payments/download/${id}`,
  GET_PAYMENT_MANAGEMENT_URL: 'clients/subscription/payments-management',
  GET_ADDON_PURCHASE_URL: (addonPaymentId: string) => `clients/subscription/Add-AddOn?AddonPaymentId=${addonPaymentId}`,
};
